/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdsPeerComponent } from './vcdsPeerComponent';
import { VcdsComponentIdAndType } from './vcdsComponentIdAndType';


export interface VcdsComponentInventoryTree { 
    peer_components?: Array<VcdsPeerComponent>;
    related_components?: Array<VcdsComponentIdAndType>;
}

